module.exports = __webpack_public_path__ + "static/media/bicycle1.85970fe8.gif";